"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

require("./index.css");

var _registerServiceWorker = require("./registerServiceWorker");

var _registerServiceWorker2 = _interopRequireDefault(_registerServiceWorker);

var _donut = require("./containers/donut");

var _donut2 = _interopRequireDefault(_donut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.render(_react2.default.createElement(_donut2.default, {
  hasEqualParts: false,
  doughnutsize: "large",
  doughnutparts: 4,
  doughnutcolors: {
    c1: "#D1A917",
    c2: "#2C9DC2",
    c3: "#D12A6A",
    c4: "#535353",
    c5: "#AC6946"
  },
  doughnutvalues: {
    p1: 5,
    p2: 20,
    p3: 25,
    p4: 30,
    p5: 20
  },
  completionrate: 240 }), document.getElementById("root"));
exports.default = _donut2.default;

(0, _registerServiceWorker2.default)();